class MessageStore {
    constructor() {
        this.messages = [];
        this.messageMap = new Map();
        this.startOffset = 0;
        this.endOffset = 0;
    }
    updateLookup(messages, isPrepend = false) {
        messages.forEach((msg, index) => {
            if (!msg.id) {
                throw new Error('Message must have a valid ID');
            }
            const globalIndex = isPrepend
                ? this.startOffset + index
                : this.endOffset + index;
            this.messageMap.set(msg.id, globalIndex);
        });
    }
    reset() {
        this.messages = [];
        this.startOffset = 0;
        this.endOffset = 0;
        this.messageMap.clear();
    }
    prepend(messages) {
        this.messages = messages.concat(this.messages);
        this.startOffset -= messages.length;
        this.updateLookup(messages, true);
    }
    initial(messages) {
        this.reset();
        this.append(messages);
    }
    append(messages) {
        this.updateLookup(messages);
        this.messages = this.messages.concat(messages);
        this.endOffset += messages.length;
    }
    _update(oldId, updatedFields) {
        const globalIndex = this.messageMap.get(oldId);
        if (globalIndex == undefined)
            return;
        const localIndex = globalIndex - this.startOffset;
        if (updatedFields.id &&
            updatedFields.id !== oldId &&
            this.messageMap.has(updatedFields.id)) {
            throw new Error(`A message with ID "${updatedFields.id}" already exists.`);
        }
        const existingMessage = this.messages[localIndex];
        const version = (existingMessage === null || existingMessage === void 0 ? void 0 : existingMessage.version) ? existingMessage.version + 1 : 1;
        this.messages[localIndex] = Object.assign(Object.assign(Object.assign({}, existingMessage), updatedFields), { version });
        if (updatedFields.id && updatedFields.id !== oldId) {
            this.messageMap.delete(oldId);
            this.messageMap.set(updatedFields.id, globalIndex);
        }
    }
    computeKey(item) {
        var _a;
        return `${item.id}_${(_a = item.version) !== null && _a !== void 0 ? _a : 0}`;
    }
    _applyUpdateFunction(oldId, updateFunction) {
        const globalIndex = this.messageMap.get(oldId);
        if (globalIndex == undefined)
            return;
        const localIndex = globalIndex - this.startOffset;
        const existingMessage = this.messages[localIndex];
        const updatedFields = updateFunction(existingMessage);
        this._update(oldId, updatedFields);
    }
    getItem(index) {
        const localIndex = index - this.startOffset;
        return this.messages[localIndex];
    }
    updateMultiple(updates) {
        updates.forEach((update) => {
            var _a, _b;
            if (update.id) {
                if ('updatedFields' in update.descriptor &&
                    'updateFunction' in update.descriptor) {
                    throw new Error('Message update descriptor cannot have both updatedFields and updateFunction');
                }
                if ('updatedFields' in update.descriptor) {
                    this._update(update.id, (_a = update.descriptor) === null || _a === void 0 ? void 0 : _a.updatedFields);
                }
                if ('updateFunction' in update.descriptor) {
                    this._applyUpdateFunction(update.id, (_b = update.descriptor) === null || _b === void 0 ? void 0 : _b.updateFunction);
                }
            }
            else {
                throw new Error('Message must have a valid ID');
            }
        });
    }
}
export default MessageStore;
